/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_4Inputs */

const en_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Alignment & Sync`)
};

const fr_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alignement et synchronisation automatiques`)
};

const de_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Ausrichtung und Synchronisierung`)
};

const it_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allineamento e sincronizzazione automatici`)
};

const ru_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое выравнивание и синхронизация`)
};

const es_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alineación y sincronización automáticas`)
};

const zh_cn2_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动对齐与同步`)
};

const ja_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動調整と同期`)
};

const hi_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित संरेखण और सिंक्रनाइज़ेशन`)
};

const pt_pt2_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinhamento e sincronização automáticos`)
};

/**
* | output |
* | --- |
* | "Automatic Alignment & Sync" |
*
* @param {Signup_Feature_Pro_4Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_4 = /** @type {((inputs?: Signup_Feature_Pro_4Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_4Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_pro_4(inputs)
	if (locale === "de") return de_signup_feature_pro_4(inputs)
	if (locale === "it") return it_signup_feature_pro_4(inputs)
	if (locale === "ru") return ru_signup_feature_pro_4(inputs)
	if (locale === "es") return es_signup_feature_pro_4(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_pro_4(inputs)
	if (locale === "ja") return ja_signup_feature_pro_4(inputs)
	if (locale === "hi") return hi_signup_feature_pro_4(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_pro_4(inputs)
	return en_signup_feature_pro_4(inputs)
});